import { Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'core-deactivate-account',
  templateUrl: './deactivate-account.component.html',
  imports: [MatDividerModule, MatButtonModule],
  standalone: true,
})
export class DeactivateAccountCoreComponent {
  deactivateAccount = output<void>();
}
